import { useCallback } from 'react';
import { useFieldArray } from 'react-hook-form';
import { CustomLabel } from 'modules/timesheet-labels/labelSchema';

export type CustomLabelsField = CustomLabel & { key: string };

type UseCustomLabelArrayProps = {
  fieldName: string;
};

type UseCustomLabelArrayReturn = {
  customLabels: CustomLabelsField[];
  addCustomLabel: (customLabel: CustomLabel) => void;
  updateCustomLabel: (customLabel: CustomLabel, position: number) => void;
  removeCustomLabel: (postion: number) => void;
  replace: (customLabel: CustomLabel[]) => void;
};

export const useCustomLabelArray = ({
  fieldName
}: UseCustomLabelArrayProps): UseCustomLabelArrayReturn => {
  const { fields, append, update, remove, replace } = useFieldArray({
    name: fieldName,
    keyName: 'key'
  });

  const addCustomLabel = useCallback(
    (customLabel: CustomLabel) => {
      append(customLabel);
    },
    [append]
  );

  const updateCustomLabel = useCallback(
    (customLabel: CustomLabel, position: number) => {
      update(position, customLabel);
    },
    [update]
  );
  const removeCustomLabel = useCallback(
    (position: number) => {
      remove(position);
    },
    [remove]
  );

  return {
    customLabels: fields as CustomLabelsField[],
    addCustomLabel,
    updateCustomLabel,
    removeCustomLabel,
    replace
  };
};
